import React, { useEffect, useState } from 'react';
import { Modal, Form, Tooltip } from 'antd';
import { Button } from '@digital/ui';

import ListMensagem from './ListMensagem';
import TextArea from 'antd/lib/input/TextArea';
import { getComentariosParecerTecnicoRevisao, salvarComentarioParecerTecnicoRevisao } from '@app/api/sas/sasProposta';
import { Visibility } from '@app/components';


interface Props {
    id?: string;
    contemComentario: boolean;
    sasPropostaId: string;
    update: () => void;
    disabled: boolean;
}

const ModalComentariosParecerTecnico = (props: Props) => {
    const { id, contemComentario, sasPropostaId, update, disabled } = props;
    const [showModal, setShowModal] = useState(false);
    const [iconeComentario, setIconeComentario] = useState('');
    const [mensagens, setMensagens] = useState([]);
    const textAreaId = `textAreaId${id}`;
    const [parecerId, setParecerId] = useState<string>(id || '');

    useEffect(() => {
        if (contemComentario === true) {
            MudarIconeAnexo();
        }
    }, [contemComentario]);

    useEffect(() => {
        if (id && id !== parecerId) {
            setParecerId(id);
        }
    }, [id]);

    useEffect(() => {
        carregarMensagens();
    }, [parecerId]);


    const MudarIconeAnexo = () => {
        setIconeComentario('has-comments');
    };

    const limparCampo = () => {
        const elemento = document.getElementById(textAreaId);
        if (elemento != null) {
            elemento.value = '';
        }
    };

    const handleCancel = () => {
        limparCampo();
        setShowModal(false);
        update();
    };

    const carregarMensagens = () => {
        if (parecerId) {
            getComentariosParecerTecnicoRevisao(parecerId).then(data => {
                setMensagens(data);
            });
        }
    };

    const Salvar = (e: any) => {
        const text = document.getElementById(textAreaId).value;
        const form = new FormData();
        form.append('parecerTecnicoRevisaoId', parecerId);
        form.append('comentario', text);
        form.append('sasPropostaId', sasPropostaId);

        salvarComentarioParecerTecnicoRevisao(form).then(data => {
            if (data.valid) {
                setParecerId(data.parecerTecnicoRevisaoId);
                limparCampo();
                carregarMensagens();
            }
        });
    };

    return (
        <>
            <Tooltip title="Comentários">
                <Button
                    onClick={() => {
                        setShowModal(true);
                        carregarMensagens();
                    }}
                    icon="messaging-comments"
                    className={iconeComentario}
                />
            </Tooltip>
            <Modal
                title="Comentário"
                className="chat-modal"
                visible={showModal}
                onCancel={() => handleCancel()}
                footer={[
                    <Button key="submitCancelar" type="link" onClick={() => handleCancel()} title='Fechar' />,
                    <Visibility visible={!disabled}>
                        <Button key="submitEnviar" type="primary" onClick={e => Salvar(e)} title='Enviar' />
                    </Visibility>
                ]}>
                <ListMensagem mensagens={mensagens} />
                <Visibility visible={!disabled}>
                    <div className="chat-modal-message-box">
                        <Form>
                            <Form.Item>
                                <TextArea id={textAreaId} placeholder="Mensagem" autosize={{ minRows: 3, maxRows: 5 }} maxLength={300} />
                            </Form.Item>
                        </Form>
                    </div>
                </Visibility>
            </Modal >
        </>
    );
};

export default ModalComentariosParecerTecnico;